import type { BaseSlideProps } from './SlideLayout.types';
import { inlineMarkdown } from '@/lib/markdown';

interface VisualContent {
  /** URL to the image (SVG, PNG, etc.) — relative to public root */
  imageUrl: string;
  /** Optional caption below the image */
  caption?: string;
  /** Optional additional text below the caption */
  text?: string;
  /** Max width for the image (default: 100%) */
  maxWidth?: string;
}

export function VisualSlide({ title, content, accentColor }: BaseSlideProps) {
  const { imageUrl, caption, text, maxWidth } = content as VisualContent;

  return (
    <div
      className="slide-content animate-fade-in-up flex flex-col items-center"
      style={{ '--color-accent': accentColor } as React.CSSProperties}
    >
      <h2 className="text-3xl font-serif font-bold mb-6 accent-text text-center">
        {title}
      </h2>

      {/* Image container */}
      <div
        className="w-full flex justify-center mb-4"
        style={{ maxWidth: maxWidth || '100%' }}
      >
        <img
          src={imageUrl}
          alt={title}
          className="w-full h-auto rounded-lg"
          style={{ maxHeight: '65vh' }}
        />
      </div>

      {/* Caption */}
      {caption && (
        <p className="text-sm text-slate-500 dark:text-slate-400 text-center italic mb-2"
           dangerouslySetInnerHTML={{ __html: inlineMarkdown(caption) }} />
      )}

      {/* Additional text */}
      {text && (
        <p className="text-base text-slate-700 dark:text-slate-300 text-center max-w-2xl leading-relaxed"
           dangerouslySetInnerHTML={{ __html: inlineMarkdown(text) }} />
      )}
    </div>
  );
}
